module.exports = __webpack_public_path__ + "img/al.89fa1ce3.svg";